import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../../redux/App/App.slice';
import { StyledDashboardPage } from './Dashboard.styles';
import { WidgetWrapperComponent } from './components/WidgetWrapper/WidgetWrapper.component';
import { DASHBOARD_PAGE_ID } from './constants/constants';

const DashboardPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Dashboard'));
  }, [dispatch]);

  return (
    <StyledDashboardPage id={DASHBOARD_PAGE_ID}>
      <WidgetWrapperComponent />
    </StyledDashboardPage>
  );
};

export default DashboardPage;
